import { jsx as _jsx } from "react/jsx-runtime";
const Line = ({ color = "var(--avinor-grey-200)", vertical = false }) => {
    return (_jsx("div", { style: {
            background: color,
            height: vertical ? "100%" : color !== "var(--avinor-grey-200)" ? "3px" : "1px",
            width: vertical ? (color !== "var(--avinor-grey-200)" ? "3px" : "1px") : "100%",
        } }));
};
export default Line;
